import React from 'react';
import ReactDOM from 'react-dom';
import getFeatureCentroid from '@mapsight/lib-ol/feature/getCentroid';

import Overlay from 'ol/Overlay';
import Select from 'ol/interaction/Select';
import * as olCondition from 'ol/events/condition';

import tooltipActions from '../../actions/tooltip-actions';
import StandTooltip from '../../components/stand-tooltip';

export default function (layers, style) {
	/** @var {HTMLElement} tooltipElement */
	const tooltipElement = document.getElementById(
		'bssp-stand-tooltip-container'
	);

	const tooltip = new Overlay({
		element: tooltipElement,
		stopEvent: false,
	});

	ReactDOM.render(<StandTooltip />, tooltip.getElement());

	const selectHover = new Select({
		layers: layers,
		style: style,
		condition: olCondition.pointerMove,
	});

	selectHover.on('select', function (evt) {
		const features = evt.selected;
		if (!features.length) {
			tooltipActions.showFeature(false);
			return;
		}
		const feature = features[0];
		const position = getFeatureCentroid(feature);
		if (!position) {
			return;
		}

		tooltipActions.showFeature(feature.getId());
		tooltip.setPosition(position);
	});

	return {tooltip: tooltip, selectHover: selectHover};
}
